import { AxiosResponse } from "axios";

import { appConstants } from "../config/app-constants";

import { IAddEditUser, IUserParams, IUserResponse } from "../config/interfaces";
import InitApi from "./init";

class UsersApi {
  static _instance: UsersApi;

  static getInstance = () => {
    if (this._instance) {
      return this._instance;
    }
    this._instance = new UsersApi();
    return this._instance;
  };

  _apiSvc;

  constructor() {
    this._apiSvc = InitApi.getInstance();
  }

  getUsers = async (params: IUserParams): Promise<{ count: number; records: IUserResponse[] }> => {
    const { search, offset = 0, count = 10, orderBy, order, role } = params;
    let url = `user?offset=${offset}`;

    if (search) {
      url += `&search=${search}`;
    }
    if (count) {
      url += `&count=${count}`;
    }
    if (orderBy) {
      url += `&orderBy=${orderBy}`;
    }
    if (order) {
      url += `&order=${order}`;
    }
    if (role) {
      url += `&role=${role}`;
    }
    const response = await this._apiSvc.get(`${appConstants.apiUrl}/${url}`);
    return response.data;
  };

  getUserById = async (uUId: string): Promise<IUserResponse> => {
    const response = await this._apiSvc.get(`${appConstants.apiUrl}/user/single/${uUId}`);
    return response.data;
  };

  addUser = async (data: IAddEditUser): Promise<IUserResponse> => {
    const response = await this._apiSvc.post(`${appConstants.apiUrl}/user`, data);
    return response.data;
  };

  updateUserById = async (uUId: string, data: IAddEditUser): Promise<IUserResponse> => {
    const response = await this._apiSvc.put(`${appConstants.apiUrl}/user/single/${uUId}`, data);
    return response.data;
  };

  updateUserStatusActive = async (uUId: string): Promise<AxiosResponse> => {
    return this._apiSvc.put(`${appConstants.apiUrl}/user/activate/${uUId}`);
  };

  updateUserStatusInactive = async (uUId: string): Promise<AxiosResponse> => {
    return this._apiSvc.put(`${appConstants.apiUrl}/user/deactivate/${uUId}`);
  };

  userChangePassword = async (
    uUId: string,
    data: { newPassword: string }
  ): Promise<AxiosResponse> => {
    return this._apiSvc.put(`${appConstants.apiUrl}/user/change-password/${uUId}`, data);
  };
}
export default UsersApi;
